if (!customElements.get("component-ways-to-buy")) {
  class WaysToBuy extends Theme.Component {

    connectedCallback() {
      super.connectedCallback();

      this.intersectionObserver((entry, observer) => {
        if (!entry.isIntersecting) return;

        observer.disconnect();
        this.classList.add("state--revealed");
      }, { threshold: 0.3 });
    }
  }

  customElements.define("component-ways-to-buy", WaysToBuy);
}
